import React from 'react';
import { Box, Grid } from 'housecall-ui';

import { FormField } from '../../components/form/FormField';
import { ContactDetailsValues } from '../../state/types';

type FieldName = keyof ContactDetailsValues;

export const NewCustomerFields = () => {
  return (
    <Box mb={2}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <FormField<FieldName>
            name="firstName"
            data-testid="online-booking-contact-firstname"
            label="First name *"
            fullWidth
            autoComplete="given-name"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField<FieldName>
            name="lastName"
            data-testid="online-booking-contact-lastname"
            label="Last name *"
            fullWidth
            autoComplete="family-name"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField<FieldName>
            name="phone"
            data-testid="online-booking-contact-phone"
            label="Phone number *"
            mask="phone"
            fullWidth
            autoComplete="tel-national"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField<FieldName>
            name="email"
            data-testid="online-booking-contact-email"
            label="E-mail address *"
            type="email"
            fullWidth
            autoComplete="email"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
